import {Component, Input} from '@angular/core';
import {DashboardBoxesHeadData} from "../../interfaces/dashboard-boxes-head-data";
import {SchoolClassDataService} from "../../services/school-class-data.service";
import {SchoolClassData} from "../../interfaces/school-class-data";
import {LineChartData} from "../../interfaces/line-chart-data";
import {ChartDataset} from "../../interfaces/chart-dataset";
import {TrophyService} from "../../services/trophy.service";
import {OrganizationTrophyItem} from "../../interfaces/organization-trophy-item";
import {OrganizationExperienceService} from "../../services/organization-experience.service";
import moment from "moment";
import {ExperienceEntry} from "../../interfaces/experience-entry";
import {PlayTimeEntry} from "../../interfaces/play-time-entry";

@Component({
  selector: 'brt-school-class-compare-block',
  templateUrl: './school-class-compare-block.component.html',
  styleUrls: ['./school-class-compare-block.component.scss']
})
export class SchoolClassCompareBlockComponent {

  private readonly COLORS: string[] = ["#CD96FB", "#FBC800", "#44ABDB", "#15a050", "#fa2027", "#f2f6ff", "#916E0E", "#2F2F5C"];
  @Input('classIds') set setClassIds(inputClassIds: number[]) {

    if(inputClassIds.length) {
      this.classIds = inputClassIds;
      this.legendItems = [];

      this.schoolClassDataService.getSchoolClasses().then((val) => {
        this.schoolClassDataRepo = val.filter((el) => {
          return inputClassIds.indexOf(el.id) !== -1;
        });

        // console.log('school-class-data-repo', this.schoolClassDataRepo);

        this.schoolClassDataRepo.forEach((schoolClassData, idx) => {
          this.legendItems.push({color: this.COLORS[idx % this.COLORS.length], label: schoolClassData.classNumber + ' ' + schoolClassData.classAddition});
        })

        this.loadPointsLineChartData();
        this.loadTrophiesData();
        this.loadPlayTimeLineChartData();
      });

    }

  }

  @Input('headlineData') set setHeadlineData(val: Partial<DashboardBoxesHeadData>) {
    this.defaultHeadlineBlockData = {
      ...this.defaultHeadlineBlockData,
      ...val
    }
  }

  schoolClassDataRepo: SchoolClassData[] = [];

  currentCategory: "points" | "trophies" | "time" = "points";

  pointsLineChartData?: LineChartData;
  playTimeLineChartData?: LineChartData;

  categoriesSelectorData = [
    {icon: "line-chart", label: "Punkte", value: "points"},
    {icon: "trophy", label: "Trophäen", value: "trophies"},
    {icon: "time", label: "Spieldauer", value: "time"}
  ];

  legendItems: any[] = [
    {color: "", label: ""}
  ]

  trophyData: {className: string; trophies: OrganizationTrophyItem[]}[] = []


  defaultHeadlineBlockData: Partial<DashboardBoxesHeadData> = {
  }

  classIds: number[] = [];

  constructor(private schoolClassDataService: SchoolClassDataService,
              private trophyService: TrophyService,
              private organizationExperienceService: OrganizationExperienceService) {
  }

  onCategorySelected($event: string) {
    this.currentCategory = $event as typeof this.currentCategory;

    if(this.currentCategory === "trophies") {
      if(this.trophyData.length === 0) {
        this.loadTrophiesData();
      }
    }
  }

  loadTrophiesData(): void {
    const promises: Promise<{className: string, trophies: OrganizationTrophyItem[]}>[] = [];
    this.schoolClassDataRepo.forEach((schoolClassData, idx) => {
      const newPromise = new Promise<{className: string, trophies: OrganizationTrophyItem[]}>((resolve, reject) => {
        this.trophyService.loadClassTrophies(schoolClassData.id).then((trophyData) => {
          resolve({
            className: schoolClassData.classNumber + ' ' + schoolClassData.classAddition,
            trophies: trophyData.items
          })
        });
      });
      promises.push(newPromise);
    });

    Promise.all(promises).then((data) => {
      this.trophyData = data;
    })
  }
  async loadPointsLineChartData() {
    const data: LineChartData = {
      datasets: []
    };

    const promises: Promise<ExperienceEntry[]>[] = [];
    this.schoolClassDataRepo.forEach((el, idx) => {
      if(el.classCode.length) {
        const promise = this.organizationExperienceService.loadSchoolClassHistoryExperience(el.classCode);
        promises.push(promise);
      }
    });

    await Promise.all(promises).then((entries) => {
      // now we need to make these entries of same length

      // let maxLength = 0; // find the longest
      // entries.forEach((entry) => {
      //   maxLength = Math.max(maxLength, entry.length)
      // });
      //
      // for(let i = 0; i < entries.length; i++) {
      //   if(entries[i].length < maxLength) {
      //     const diff = maxLength - entries[i].length;
      //
      //     for(let j = 0; j < diff; j++) {
      //       entries[i].push({points: 0, date: "2024-10-10 02:00:02"});
      //     }
      //   }
      // }


      // entries = entries.filter(el => el.length > 0);

      // entries = entries.map((el) => {
      //   return el.slice(0, Math.floor(Math.random() * 4) + 1);
      // });
      entries.forEach((entry, idx) => {
        const dataset: ChartDataset = {items: [], label: "el.classCode", color: this.COLORS[idx % this.COLORS.length]};

        const entriesReversed = entry.reverse();
        // console.log(el.classCode);
        // console.log(pointsHistory[0]);
        entriesReversed.forEach((entry) => {
          if(entry.date.length) {
            const pointEntryDate = moment(entry.date, "YYYY-MM-DD hh:mm:ss"); // "2024-08-08 04:00:02"
            // console.log(pointEntryDate);

            dataset.items.push({
              // @ts-ignore
              label: pointEntryDate.valueOf(),
              value: entry.points
            })
          }

        });


        data.datasets.push(dataset);
      })

    });

    // data.datasets = data.datasets.filter(el => el.items.length > 0);

    // This block of code fills empty datasets with single item
    // Value = 0, Date = earliest date in the first not empty dataset
    // const emptyDatasets = data.datasets.filter((dataset) => dataset.items.length === 0);
    // if(emptyDatasets.length !== data.datasets.length && emptyDatasets.length > 0) {
    //   const datasetWithData = data.datasets.findIndex((dataset) => dataset.items.length !== 0);
    //
    //   data.datasets = data.datasets.map((dataset) => {
    //     if(dataset.items.length > 0) return dataset;
    //
    //     dataset.items = [
    //       {
    //         ...data.datasets[datasetWithData].items[0],
    //         value: 0
    //       }
    //     ]
    //     return dataset;
    //   })
    //   //
    // }

    // console.log(data);
    this.pointsLineChartData = data;
  }

  async loadPlayTimeLineChartData() {
    const data: LineChartData = {
      datasets: []
    };

    const promises: Promise<PlayTimeEntry[]>[] = [];
    this.schoolClassDataRepo.forEach((el, idx) => {
      if(el.classCode.length) {
        const promise = this.organizationExperienceService.loadSchoolClassHistoryPlayTime(el.classCode);
        promises.push(promise);
      }
    });

    await Promise.all(promises).then((entries) => {
      // console.log(entries);
      entries = entries.filter(el => el.length > 0);
      entries.forEach((entry, idx) => {
        const dataset: ChartDataset = {items: [], label: "", color: this.COLORS[idx % this.COLORS.length]};

        const entriesReversed = entry.reverse();
        // console.log(el.classCode);
        // console.log(pointsHistory[0]);
        entriesReversed.forEach((entry) => {
          if(entry.date.length) {
            const pointEntryDate = moment(entry.date, "YYYY-MM-DD hh:mm:ss"); // "2024-08-08 04:00:02"
            // console.log(pointEntryDate);

            dataset.items.push({
              // @ts-ignore
              label: pointEntryDate.valueOf(),
              value: entry.playTime / 60 / 60
            })
          }

        });


        data.datasets.push(dataset);
      })

    });

    // This block of code fills empty datasets with single item
    // Value = 0, Date = earliest date in the first not empty dataset
    const emptyDatasets = data.datasets.filter((dataset) => dataset.items.length === 0);
    if(emptyDatasets.length !== data.datasets.length && emptyDatasets.length > 0) {
      const datasetWithData = data.datasets.findIndex((dataset) => dataset.items.length !== 0);

      data.datasets = data.datasets.map((dataset) => {
        if(dataset.items.length > 0) return dataset;

        dataset.items = [
          {
            ...data.datasets[datasetWithData].items[0],
            value: 0
          }
        ]
        return dataset;
      })
      //
    }
    this.playTimeLineChartData = data;
  }
}
